import { useTranslation } from 'react-i18next';

import * as St from './CanvasToolbar.styles';
import useToolBar from './useToolbar';

import ToolbarItem from '~/UI/components/molecules/ToolbarItem';
import ConfirmationDialog from '~molecules/ConfirmationDialog';

const CanvasToolbar = (): JSX.Element => {
  const { t } = useTranslation();
  const {
    isModalVisible,
    closeModal,
    toolbarButtons,
    removeShapeOrAppliance,
    selectedObjectName,
  } = useToolBar();
  const [mainToolbarButtons, zoomToolbarButtons] = toolbarButtons.map((btns) =>
    btns.map((btn) => (
      <ToolbarItem
        key={btn.name}
        name={btn.name}
        isEnabled={btn.isEnabled}
        onClick={btn.onClick}
      />
    ))
  );

  return (
    <>
      <St.Toolbar>{mainToolbarButtons}</St.Toolbar>
      <St.VerticalToolbar>{zoomToolbarButtons}</St.VerticalToolbar>

      <ConfirmationDialog
        title={t('SCROLLABLE_AREA.ADDRESS_INFORMATION.DELETE_SHAPE', {
          selectedDrawingObjectName: selectedObjectName,
        })}
        visible={isModalVisible}
        content={t('SCROLLABLE_AREA.COUNTERTOP.REMOVE_COUNTERTOP_DESCRIPTION')}
        onCancel={closeModal}
        onConfirm={() => {
          removeShapeOrAppliance();
          closeModal();
        }}
      />
    </>
  );
};

export default CanvasToolbar;
